import { Yup, type YupTypes } from "../../../form"

export enum ImportCsvDialogFields {
  CSV = "csv-file",
}

export const importCsvDialogSchema = Yup.object().shape({
  [ImportCsvDialogFields.CSV]: Yup.array()
    .of(Yup.mixed<File>())
    .length(1)
    .required(),
})
export type ImportCsvDialogFormValues = YupTypes.InferType<
  typeof importCsvDialogSchema
>
